<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('attendanceAttemptsCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="attendance-attempts-workspace">
      <app-master-table
        [title]="'attendanceAttemptsCatalog.title' | translate"
        [dataSource]="dataSource"
        [columnDefinitions]="columnDefinitions"
        [actions]="actions"
        [filters]="tableFilters"
        [isLoading]="isLoading"
        [enableRowClick]="false"
        [rowClickSelection]="true"
        [showContextMenu]="false"
        [tableMaxHeight]="'560px'"
        [exportFileName]="'attendance-attempts'"
        [searchValue]="searchValue"
        (add)="handleAdd()"
        (refresh)="loadData()"
        (details)="handleView($event)"
        (delete)="handleDelete($event)"
        (bulkDelete)="handleBulkDelete($event)"
        (searchChange)="onSearchChange($event)"
        (filtersChange)="onFiltersChange($event)"
        (filterSearchChange)="onFilterSearchChange($event)">
      </app-master-table>
    </div>
  </div>
</section>

